<ng-container>
    <mat-icon class="absolute items-center h-16 ml-6 sm:ml-8" [svgIcon]="'heroicons_outline:search'"></mat-icon>
    <input class="w-full h-full pl-16 pr-8 sm:pl-18" [formControl]="searchControl" [matAutocomplete]="matAutocomplete"
        [placeholder]="'Search for a page or a contact'" (keydown)="onKeydown($event)" #barSearchInput>
    <mat-autocomplete class="w-full max-h-128 sm:px-2 border-t rounded-b shadow-md" [disableRipple]="true"
        #matAutocomplete="matAutocomplete">
        <mat-option class="py-0 px-6 text-md pointer-events-none text-secondary bg-transparent"
            *ngIf="resultSets && !resultSets.length">
            No results found!
        </mat-option>
        <ng-container *ngFor="let resultSet of resultSets; trackBy: trackByFn">
            <mat-optgroup class="flex items-center mt-2 px-2">
                <span
                    class="text-sm font-semibold tracking-wider text-secondary">{{resultSet.label.toUpperCase()}}</span>
            </mat-optgroup>
            <ng-container *ngFor="let result of resultSet.results; trackBy: trackByFn">
                <mat-option
                    class="group relative mb-1 py-0 px-6 text-md rounded-md hover:bg-gray-100 dark:hover:bg-hover"
                    [routerLink]="result.link">
                    <!-- Contacts -->
                    <ng-container *ngIf="resultSet.id === 'contacts'">
                        <ng-container *ngTemplateOutlet="contactResult; context: {$implicit: result}"></ng-container>
                    </ng-container>
                    <!-- Pages -->
                    <ng-container *ngIf="resultSet.id === 'pages'">
                        <ng-container *ngTemplateOutlet="pageResult; context: {$implicit: result}"></ng-container>
                    </ng-container>
                    <!-- Tasks -->
                    <ng-container *ngIf="resultSet.id === 'tasks'">
                        <ng-container *ngTemplateOutlet="taskResult; context: {$implicit: result}"></ng-container>
                    </ng-container>
                </mat-option>
            </ng-container>
        </ng-container>
    </mat-autocomplete>
</ng-container>
